<template>
  <Legacy
    view="edi"
    action="home"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'EDI',
      breadcrumb: {
        name: 'EDI',
        route: { name: 'manage-edi' }
      }
    }
  }
}
</script>
